// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { paperclip16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-paperclip': IconPaperclip;
    }
}

/**
 * The icon component for the 'paperclip' icon
 */
export class IconPaperclip extends Icon {
    public constructor() {
        super(paperclip16X16);
    }
}

registerIcon('icon-paperclip', IconPaperclip);
export const iconPaperclipTag = 'nimble-icon-paperclip';
